import React from 'react';

import { ActionIcon, Box, Group, Text, createStyles, useMantineTheme } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { AthleteKiloClassWithAthlete } from 'types';

const useStyles = createStyles(theme => ({
  row: {
    display: 'grid',
    alignItems: 'center',
    padding: theme.spacing.xs,
    gridTemplateColumns: 'auto auto min-content',
    gridTemplateRows: 'auto',
    gap: theme.spacing.sm,
    borderTop: `1px solid ${theme.colors.gray[3]}`,
  },
}));

interface ILateCancelAthletesProps {
  athleteKiloClass: AthleteKiloClassWithAthlete;
  index: number;
  handleDeleteModal: (id: string) => void;
  permission?: boolean;
}

const LateCancelNoShowAthletes = ({
  athleteKiloClass,
  index,
  handleDeleteModal,
  permission = true,
}: ILateCancelAthletesProps): JSX.Element => {
  const theme = useMantineTheme();
  const { classes } = useStyles();
  const navigate = useNavigate();

  const handleNameClick = (): void => {
    navigate(`/users/athletes/${athleteKiloClass.athlete.athleteId}/general-info`);
  };

  return (
    <Box className={classes.row}>
      <Group>
        <Text c='dimmed' size='sm'>
          {index + 1}
        </Text>
        <Text
          fw='bold'
          size='sm'
          underline
          sx={{ cursor: 'pointer', width: 'fit-content' }}
          onClick={() => handleNameClick()}
        >
          {athleteKiloClass.athlete.fullName}
        </Text>
      </Group>
      {athleteKiloClass.isLateCancel && <Text c='dimmed'>Late Cancel</Text>}
      {athleteKiloClass.isNoShow && <Text c='dimmed'>No Show</Text>}
      <ActionIcon
        onClick={() => handleDeleteModal(athleteKiloClass.athleteKiloClassId)}
        variant='transparent'
        color='gray.7'
        disabled={!permission}
      >
        <IconTrash size={theme.fontSizes.xl} />
      </ActionIcon>
    </Box>
  );
};

export default LateCancelNoShowAthletes;
